export default __webpack_public_path__ + "static/media/logo.06cf36e5.png";